import {
  AtoB,
  UrlWithOnlyOrgId,
  getAllParamsAsStringFromUrl,
  isValidBase64,
  replaceUrl,
  safeAtoB
} from '../utils/UrlUtils'
import React, { useEffect, useState } from 'react'
import {
  deleteToken,
  getDataFromCookie,
  isAuthenticatedUser,
  saveCookie
} from '../utils/AuthUtils'
import { gaEventConstants, gaPageConstants } from '../constants/GAConstants'
import {
  getUserDetails,
  getUserPreference,
  resendVerification
} from '../api/user/User.service'
import { isEmpty, isNull, isObject, isUndefined } from 'lodash'
import { useLocation, useNavigate, useSearchParams } from 'react-router-dom'

import { DDSTypography } from 'den-design-system'
import { OrganizationUserRoles } from '../enum/OrganizationUserRoles.enum'
import PageLoadingOverlay from '../components/common/PageLoadingOverlay/PageLoadingOverlay'
import { SettingAddPopup } from './NewVersion/Settings/SettingPopups/SettingAddPopup'
import StringConstants from '../constants/StringConstants'
import { ToastMessageConstants } from '../constants/ToastMessageConstants'
import ToastNotification from '../components/common/DDS/Toast/Toast'
import { joinUserToRoom } from '../gateway'
import { login } from '../api/Auth.service'
import palette from '../global/pallete'
import pallete from '../global/newPallete'
import routeConstants from '../constants/RouteConstants'
import styled from '@emotion/styled'
import { useAnalyticsEventTracker } from '../utils/GAUtils'
import { useStoreContext } from '../store/StoreContext'

const RedirectScreen: React.FC = () => {
  const Container = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-top: 50px;
    gap: 10px;
  `
  const ColorText = styled.div`
    color: ${palette.colors.primary};
    display: inline;
  `
  const location = useLocation()
  const isDemo = window.location.host.includes('demo.vigilnow.com')
  const [searchParams, setSearchParams] = useSearchParams()
  const navigate = useNavigate()
  const [open, setOpen] = useState(false)
  const storeContext = useStoreContext()
  const token = searchParams.get('token')
  const [loading, setLoading] = useState(false)

  const removeSandboxUserDetails = () => {
    localStorage.removeItem('project_type')
    localStorage.removeItem('tour_disabled')
    localStorage.removeItem('sandboxuser_email')
    localStorage.removeItem('sandboxuser_role')
  }

  const callRedirect = () => {
    const redirect = searchParams.get('redirect')
    if (token) {
      saveCookie(StringConstants.COOKIE_TOKEN, token)
      redirectUser(true)
    } else if (isAuthenticatedUser()) {
      if (redirect) {
        const otherParams = getAllParamsAsStringFromUrl(location.search, [
          'redirect'
        ])
        redirectUser(false, redirect + otherParams)
      } else {
        redirectUser()
      }
    } else {
      //TODO paste it below sandbox url
      if (window.location.host.includes('demo.vigilnow.com')) {
        navigate(routeConstants.SANDBOX_SCREEN)
        removeSandboxUserDetails()
      } else {
        navigate(routeConstants.SIGN_IN)
      }
    }
  }
  const gaEventTracker = useAnalyticsEventTracker(gaPageConstants.VERIFY)

  useEffect(() => {
    if (token) {
      saveCookie(StringConstants.COOKIE_TOKEN, token as string)
      callRedirect()
    } else if (isUndefined(token) || isNull(token)) {
      callRedirect()
    }
  }, [])

  const demoLogin = () => {
    const email = 'demo-vigil@gmail.com'
    const pwd = 'Password1!'
    login({ email: email, password: pwd, captcha: null })
      .then((response: any) => {
        //TODO
        // store token in cookie
        // call redirectUser(false, 'overview' + a2b(org details))
        saveCookie(
          StringConstants.COOKIE_TOKEN,
          response?.data.accessToken as string
        )
        redirectUser()
      })
      .catch((err: string) => {
        console.log('ERROR ::::::::', err)
        ToastNotification({
          type: 'error',
          message: ToastMessageConstants.AUTH.SIGN_IN.ERROR
        })
      })
  }

  const handleStoredRedirectPath = () => {
    const storedRedirectPath = sessionStorage.getItem('redirectPath')
    if (storedRedirectPath) {
      console.log('Found stored redirect path:', storedRedirectPath)
      return storedRedirectPath
    }
    return null
  }
  const redirectUser = (reload?: boolean, redirect?: string) => {
    const authToken = getDataFromCookie()
    if (!isEmpty(authToken)) {
      storeContext.uiStore.setGlobalLoader(true)
      getUserDetails()
        .then((response: any) => {
          setOpen(!response.data.isVerified)

          storeContext.userStore.setId(response.data.id)
          storeContext.userStore.setEmail(response.data.email)
          storeContext.userStore.setAvatar(response.data.avatar)
          storeContext.userStore.setIsVerified(response.data.isVerified)
          storeContext.userStore.setOnBoardedVia(response.data.onBoardedVia)

          const storedRedirectPath = handleStoredRedirectPath()

          const finalRedirect = storedRedirectPath || redirect

          // const referrer = searchParams.get('referrer')
          let lastVisitedOrgDetails = localStorage.getItem(
            StringConstants.LOCAL_STORAGE.CURRENT_PAGE_DETAILS
          )

          let organizationId =
            storeContext.scopeStore.getScope()['organization-id']
          // if referrer and details in local storage exists
          if (lastVisitedOrgDetails) {
            lastVisitedOrgDetails = JSON.parse(lastVisitedOrgDetails)

            // if parsed local storage details exists
            if (isObject(lastVisitedOrgDetails)) {
              // assign the last accessed org, project and env id
              storeContext.scopeStore.setOrganizationId(
                lastVisitedOrgDetails['organization-id']
              )
              organizationId = lastVisitedOrgDetails?.['organization-id']
              storeContext.scopeStore.setProjectId(
                lastVisitedOrgDetails?.['project-id']
              )
              storeContext.scopeStore.setEnvironmentId(
                lastVisitedOrgDetails?.['environment-id']
              )
            }
          }
          if (
            !isUndefined(finalRedirect) &&
            !isNull(finalRedirect) &&
            finalRedirect.split('/')[1] !== 'slack'
          ) {
            const state = searchParams.get('state')
            if (state) {
              const decodedState = AtoB(state)

              try {
                const headerObj = JSON.parse(decodedState)

                storeContext.scopeStore.setOrganizationId(
                  headerObj.organizationId
                )
                organizationId = headerObj.organizationId
                if (headerObj.projectId)
                  storeContext.scopeStore.setProjectId(headerObj.projectId)
                if (headerObj.environmentId)
                  storeContext.scopeStore.setEnvironmentId(
                    headerObj.environmentId
                  )
              } catch (error) {
                console.error('Failed to parse decoded state:', error)
              }
            } else {
              const redirectPath = finalRedirect.split('/')
              const encodedPart = redirectPath[1]
              const decoded = isValidBase64(encodedPart)
                ? safeAtoB(encodedPart)
                : null
              const decodedUrlSplit = decoded?.split('/') || []

              const allProjectIds = response.data.organizations.flatMap(
                (org: any) =>
                  Array.isArray(org.projectIds) ? org.projectIds : []
              )
              if (
                Array.isArray(decodedUrlSplit) &&
                decodedUrlSplit[1] &&
                allProjectIds.length > 0 &&
                !allProjectIds.includes(decodedUrlSplit[1])
              ) {
                sessionStorage.removeItem('redirectPath')
                navigate(routeConstants.UNAUTHORIZED_PAGE)
                return
              }

              storeContext.scopeStore.setOrganizationId(decodedUrlSplit[0])
              organizationId = decodedUrlSplit[0]
              if (decodedUrlSplit[1])
                storeContext.scopeStore.setProjectId(decodedUrlSplit[1])
              if (decodedUrlSplit[2])
                storeContext.scopeStore.setEnvironmentId(decodedUrlSplit[2])
            }
          }

          const selectedOrganization = response.data.organizations.filter(
            (record: any) => record.id === organizationId
          )
          if (selectedOrganization.length === 1) {
            storeContext.userStore.setUserRole(
              selectedOrganization[0].membership.role
            )
            storeContext.userStore.setCustomerStripeId(
              selectedOrganization[0].stripeCustomerId
            )
            storeContext.userStore.setOrganizationDetails(
              selectedOrganization[0]
            )
            storeContext.userStore.setSelectedOrganization(
              selectedOrganization[0]
            )
            const org = selectedOrganization[0]

            if (!org?.subscription || org.subscription.status === 'canceled') {
              storeContext.userStore.setNoActiveSubscription(true)
            } else {
              storeContext.userStore.setNoActiveSubscription(false)
            }
          } else if (response.data.organizations.length > 0) {
            storeContext.userStore.setUserRole(
              response.data.organizations[0].membership.role
            )

            storeContext.scopeStore.setOrganizationId(
              response.data.organizations[0].id
            )
            const org = response?.data?.organizations?.[0]

            if (!org?.subscription || org.subscription.status === 'canceled') {
              storeContext.userStore.setNoActiveSubscription(true)
            } else {
              storeContext.userStore.setNoActiveSubscription(false)
            }
          }

          storeContext.userStore.setFirstName(response.data.firstName)
          storeContext.userStore.setPhoneNumber(response.data.phoneNumber)
          storeContext.userStore.setIsSmsOptedIn(response.data.isSmsOptedIn)
          storeContext.userStore.setLastName(response.data.lastName)
          storeContext.userStore.setOrganizations(response.data.organizations)
          joinUserToRoom(response.data.id)
          if (open || response.data.isVerified || isNull(token)) {
            if (response.data.organizations.length === 0) {
              if (
                [
                  routeConstants.ACCOUNT_SETTING,
                  routeConstants.NOTIFICATIONS,
                  routeConstants.INVITES
                ].includes(finalRedirect?.split('?')[0] as string)
              )
                navigate(finalRedirect as string)
              else navigate(routeConstants.NO_ORGANIZATION)
            } else if (
              selectedOrganization &&
              selectedOrganization[0]?.projectCount === 0 &&
              storeContext.userStore.getUserRole() !==
                OrganizationUserRoles.BILLING
            ) {
              if (
                [routeConstants.NOTIFICATIONS, routeConstants.INVITES].includes(
                  finalRedirect?.split('?')[0] as string
                )
              )
                navigate(finalRedirect as string)
              else {
                storeContext.uiStore.setGlobalLoader(false)
                storeContext.uiStore.setprojectEnvironmentLoader(false)
                navigate(
                  UrlWithOnlyOrgId(routeConstants.NO_PROJECT, storeContext)
                )
              }
            } else if (finalRedirect) {
              let updatedRedirect = finalRedirect
              if (selectedOrganization[0]?.projectCount > 0) {
                updatedRedirect = finalRedirect.replace('noProject', 'overview')
              }
              if (updatedRedirect === '/') {
                sessionStorage.setItem(
                  StringConstants.ACTIVE_TAB,
                  StringConstants.TAB_VALUES.OVERVIEW
                )
                navigate(
                  replaceUrl(
                    routeConstants.OVERVIEW,
                    storeContext.scopeStore.getScope()[
                      'organization-id'
                    ] as string,
                    storeContext.scopeStore.getScope()['project-id'] as string,
                    storeContext.scopeStore.getScope()[
                      'environment-id'
                    ] as string
                  )
                )
              } else if (
                storeContext.userStore.getUserRole() ===
                OrganizationUserRoles.BILLING
              ) {
                storeContext.uiStore.setGlobalLoader(false)
                storeContext.uiStore.setprojectEnvironmentLoader(false)
                sessionStorage.setItem(
                  StringConstants.ACTIVE_TAB,
                  StringConstants.TAB_VALUES.SETTINGS
                )
                navigate(
                  replaceUrl(
                    routeConstants.MANAGE_ORGANIZATION,
                    storeContext.scopeStore.getOrganizationId() as string,
                    '',
                    ''
                  ) + '?tab=3'
                )
              } else {
                sessionStorage.removeItem('redirectPath')
                navigate(updatedRedirect)
              }
            } else {
              if (
                storeContext.userStore.getUserRole() ===
                OrganizationUserRoles.BILLING
              ) {
                sessionStorage.setItem(
                  StringConstants.ACTIVE_TAB,
                  StringConstants.TAB_VALUES.SETTINGS
                )
                navigate(
                  replaceUrl(
                    routeConstants.MANAGE_ORGANIZATION,
                    storeContext.scopeStore.getOrganizationId() as string,
                    '',
                    ''
                  ) + '?tab=3'
                )
              } else {
                if (
                  !isEmpty(storeContext.scopeStore.getScope()['project-id']) &&
                  !isEmpty(storeContext.scopeStore.getScope()['environment-id'])
                ) {
                  sessionStorage.setItem(
                    StringConstants.ACTIVE_TAB,
                    StringConstants.TAB_VALUES.OVERVIEW
                  )
                  navigate(
                    replaceUrl(
                      routeConstants.OVERVIEW,
                      storeContext.scopeStore.getScope()[
                        'organization-id'
                      ] as string,
                      storeContext.scopeStore.getScope()[
                        'project-id'
                      ] as string,
                      storeContext.scopeStore.getScope()[
                        'environment-id'
                      ] as string
                    )
                  )
                } else {
                  sessionStorage.setItem(
                    StringConstants.ACTIVE_TAB,
                    StringConstants.TAB_VALUES.OVERVIEW
                  )
                  navigate(
                    '../' +
                      replaceUrl(
                        routeConstants.OVERVIEW,
                        storeContext.scopeStore.getOrganizationId() as string,
                        '',
                        ''
                      )
                  )
                }
              }
            }
          }
        })
        .catch(async (err: any) => {
          console.log('err', err)
          await deleteToken()
          sessionStorage.removeItem('redirectPath')
          if (window.location.host.includes('demo.vigilnow.com')) {
            navigate(routeConstants.SANDBOX_SCREEN)
            removeSandboxUserDetails()
          } else navigate(routeConstants.SIGN_IN)
        })
    } else if (reload) {
      navigate(0)
    } else {
      if (window.location.host.includes('demo.vigilnow.com')) {
        navigate(routeConstants.SANDBOX_SCREEN)
        removeSandboxUserDetails()
      } else navigate(routeConstants.SIGN_IN)
    }
  }

  return token && !isDemo && open ? (
    //TODO Refactor this pop-up into seperate function
    <div className='override-model-verify-min-width'>
      <SettingAddPopup
        showHeader
        title='Verify Account'
        modalOpen={open}
        setModalOpen={setOpen}
        primaryButtonText='Verify'
        primaryButtonDisabled={loading}
        secondaryButtonDisabled={loading}
        secondaryButtonText='Ignore'
        loading={loading}
        primaryButtonClick={() => {
          setOpen(true)
          gaEventTracker(gaEventConstants.VERIFY)
          setLoading(true)
          resendVerification()
            .then(() =>
              ToastNotification({
                type: 'success',
                message: ToastMessageConstants.USER.RESEND_VERIFICATION.SUCCESS
              })
            )
            .catch((err: any) => {
              ToastNotification({
                type: 'error',
                message: err
              })
            })
            .finally(() => setLoading(false))
          callRedirect()
        }}
        secondaryButtonClick={async () => {
          try {
            setOpen(true)
            setLoading(true)

            gaEventTracker(gaEventConstants.IGNORE)
            await callRedirect()
          } catch (error) {
            console.error('Redirect failed:', error)
          } finally {
            setLoading(false)
          }
        }}
        showFooter={true}
        content={
          <div className='flex flex-col p-[24px] gap-[24px]'>
            <div>
              <DDSTypography.Title
                variant='semiBold'
                type='h4'
                color={pallete.colors.textDark3}
              >
                Your account is not verified yet.
              </DDSTypography.Title>
            </div>
          </div>
        }
      />
    </div>
  ) : (
    <PageLoadingOverlay />
  )
}

export default RedirectScreen
